/**
 * To add a new icon, follow these steps:
 *
 * https://github.com/LeafLink/stash/blob/main/CONTRIBUTING.md#adding-a-new-icon
 */
export const iconNames = [
  'action-dots',
  'activity',
  'alert-bell',
  'archive',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'badge-discount',
  'badge-seller-elite',
  'badge-seller-power',
  'badge-seller-verified',
  'bank',
  'book-customer',
  'building-office',
  'bulk-add',
  'calendar-reschedule',
  'calendar',
  'camera',
  'caret-down',
  'caret-up',
  'change-log',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle-check',
  'circle-close',
  'circle-dollar',
  'circle-empty',
  'circle-info',
  'circle-partial',
  'circle-percent',
  'circle-question-mark',
  'circle-slash',
  'circle-status',
  'circle-warning',
  'clipboard-checkmark',
  'clipboard-inventory',
  'close',
  'cloud-share',
  'combine',
  'compass',
  'contact',
  'contract',
  'copy',
  'credit-card',
  'credit-profile',
  'dashboard',
  'document-accept',
  'document-invoice',
  'document-recieved',
  'document-sent',
  'document-view',
  'document',
  'dolly',
  'download',
  'edit',
  'ellipsis',
  'envelope-open',
  'envelope',
  'equals',
  'export',
  'face-id',
  'face',
  'featured-no-check',
  'figma',
  'file-csv',
  'file',
  'filter-funnel',
  'filter-line',
  'fingerprint',
  'flag',
  'folder',
  'folder-bar-graph',
  'folder-orders',
  'font-bold',
  'font-clear-format',
  'font-italic',
  'font-underline',
  'gear',
  'github',
  'globe',
  'graph-bar-chart',
  'graph-line-chart',
  'graph-pie-chart',
  'hazard',
  'hazard-outline',
  'headset-agent',
  'headset-mic',
  'heart-filled',
  'heart-outline',
  'help-question-mark',
  'hide',
  'history',
  'home',
  'image',
  'import',
  'keyboard-return',
  'tier-1',
  'tier-2',
  'tier-3',
  'license-approved',
  'license-certificate',
  'lightbulb',
  'link-add',
  'link-unlink',
  'link',
  'list-bulleted',
  'list-items',
  'list-numbered',
  'loading-big',
  'loading-empty',
  'loading-small',
  'location',
  'lock-unlock',
  'lock',
  'logo-facebook',
  'logo-instagram',
  'logo-linkedin',
  'logo-ll',
  'logo-metrc',
  'logo-plaid',
  'logo-x',
  'logo-youtube',
  'logout',
  'medical',
  'megaphone-sound',
  'megaphone',
  'menu',
  'message-dispute',
  'message-reply',
  'message',
  'minus',
  'mj-leaf',
  'money',
  'note-add',
  'note',
  'open-in-new',
  'paperclip',
  'paper-plane',
  'performance',
  'phone',
  'plus',
  'preview',
  'print',
  'product-menu-manage',
  'product-menu-search',
  'product-menu',
  'queue-add',
  'queue',
  'recent',
  'refresh',
  'register',
  'reorder',
  'reply',
  'report-download',
  'sample',
  'save',
  'scale-law',
  'scale-weight',
  'search',
  'seed-cycle',
  'share',
  'shop-bag-browse',
  'shop-bag-reorder',
  'shop-bag',
  'shop-basket',
  'shop-cart-add',
  'shop-cart',
  'show',
  'sign-dollar',
  'sign-percent',
  'sort',
  'split',
  'star-filled',
  'star-outline',
  'start',
  'storefront',
  'submit',
  'swap-horizontal',
  'swap-vertical',
  'tag-star',
  'tag',
  'tag-leaf',
  'test-results',
  'ticket-star',
  'ticket',
  'tool-dropper',
  'tool-wrench',
  'transfer',
  'trashcan',
  'truck',
  'upload',
  'user-add',
  'user-admin',
  'user-check',
  'user-group',
  'user',
  'view-card',
  'view-detailed',
  'view-list',
  'warehouse',
  'working',
] as const;

export type IconName = (typeof iconNames)[number];

export enum IconSizes {
  Standard = 'standard',
  Dense = 'dense',
  Small = 'small',
  Large = 'large',
}

export type IconSize = `${IconSizes}`;
